module.exports = __webpack_public_path__ + "img/Ga Express Lane TE.a8cd736a.svg";